<div class="d-flex pb-2 mb-md-0">
    <div class="flex-grow-1">
        <div class="back-and-title">
            <abi-back-button></abi-back-button>
            <h4>{{ 'Job.Open' | translate }}</h4>
        </div>
    </div>
    <div class="ml-2">
        <button [matMenuTriggerFor]="actionMenu" class="btn btn-outline-primary dropdown-toggle">{{ 'System.Actions' | translate }}</button>
        <mat-menu #actionMenu="matMenu" class="py-0">
            <mat-action-list>
                <abi-web-layout [pageId]="pageName" [columns]="dueColumns" [extras]="layoutExtras.bind(this)" [layoutId]="layoutId" [layouts]="layouts">
                </abi-web-layout>
            </mat-action-list>
        </mat-menu>
    </div>
</div>

<div class="row pb-0">
  <div class="col-md-6 order-md-1 order-6 pb-2 pb-md-0">
    <ul ngbNav #nav="ngbNav"  class="nav-pills" activeId="due" (navChange)="tabPageChange($event)">
      <li ngbNavItem="due">
        <a ngbNavLink translate="JobSummary.DueDays"></a>
        <ng-template ngbNavContent>
          <div class="table-responsive">
            <table #table [abi-table]="pageName" [columns]="dueColumns" [rows]="dueDays" [alwaysSort]="true"
              class="due-days table-hover table-striped table-sm" [canFilter]="true">
              <ng-template [td]="['id_link']" let-row="row"
                let-value="value">
                <span class="drilldown text-truncate d-inline-block w-99">
                  <a [routerLink]="drilldownLink(row)">{{ value || ('JobSummary.Unknown' | translate) }}</a>
                </span>
              </ng-template>

              <ng-template [td]="['id']" let-row="row"
                let-value="value">
                <span class="summary text-truncate d-inline-block w-99">
                  <a [routerLink]="summaryLink(row, null)">{{ value || ('JobSummary.Unknown' | translate) }}</a>
                </span>
              </ng-template>

              <!--ng-template td="dealerId" let-row="row">
                <a [abiLookupFunc]="row.id" listName="DealerBranch" [routerLink]="drilldownLink(row)"
                  [formatter]="branchDisplay"></a>
              </ng-template-->

              <ng-template [td]="getDueColumns()" let-row="row" let-col="column" let-value="value">
                <a *ngIf="value" [ngClass]="['due-button btn btn-sm', getDueClass(col.day)]" [routerLink]="summaryLink(row, col)">{{ value
                  }}</a>
              </ng-template>

              <ng-template
                [tf]="['overdue','yesterday','bookedDay0','bookedDay1','bookedDay2','later','totalJobs','days1','days2','days3','days4']"
                let-column>
                {{ sumDue(column.field) }}
              </ng-template>

              <ng-template [tf]="['id', 'id_link']">
                {{ 'JobSummary.Totals' | translate }}
              </ng-template>
            </table>
          </div>
        </ng-template>
      </li>
      <li ngbNavItem="open">
        <a ngbNavLink translate="JobSummary.OpenDays"></a>
        <ng-template ngbNavContent>
          <div class="table-responsive">
            <table abi-table [columns]="openColumns" [rows]="openDays" [alwaysSort]="true"
              class="open-days table-hover table-striped table-sm" [canFilter]="true">
              <ng-template [td]="['id_link']" let-row="row"
                let-value="value">
                <span class="drilldown text-truncate d-inline-block w-99">
                  <a [routerLink]="drilldownLink(row)">{{ value }}</a>
                </span>
              </ng-template>

              <ng-template [td]="['id']" let-row="row"
                let-value="value">
                <span class="summary text-truncate d-inline-block w-99">
                  <a [routerLink]="summaryLink(row, null)">{{ value }}</a>
                </span>
              </ng-template>

              <ng-template [td]="getOpenColumns()" let-row="row" let-col="column" let-value="value">
                <a *ngIf="value" [ngClass]="['due-button btn btn-sm', getDueClass(col.day)]" [routerLink]="summaryLink(row, col)">{{ value
                  }}</a>
              </ng-template>

              <ng-template
                [tf]="['overdue','yesterday','bookedDay0','bookedDay1','bookedDay2','later','totalJobs','days1','days2','days3','days4']"
                let-column>
                {{ sumOpen(column.field) }}
              </ng-template>

              <ng-template [tf]="['id', 'id_link']">
                {{ 'JobSummary.Totals' | translate }}
              </ng-template>

            </table>
          </div>
        </ng-template>
      </li>
    </ul>
  </div>
  <abi-form-field class="col-md-6 order-2" *ngIf="!filter1; else level1z" label="JobSummary.Level1" labelColClass="col-3">
    <select [ngModel]="level1" class="custom-select form-control-sm" (change)="groupLevel1($event.target.value)">
      <option *ngFor="let g of groupings" [value]="g.id">{{ g.name | translate }}</option>
    </select>
  </abi-form-field>

  <ng-template #level1z>
    <abi-form-field class="col-md-6 order-2"  [label]="groupingName(level1)" labelColClass="col-3" >
      <input type="text" class="form-control-sm" [(ngModel)]="filter1" abiProductHint="JobSummary.Level1Filter" aria-label="Level 1 filter"
        aria-describedby="button-filter1" readonly class="form-control-plaintext form-control-sm float-left w-60">
      <button class="btn btn-outline-secondary d-print-none float-right" type="button" id="button-filter1"
        (click)="groupLevel1(null)">
        <i class="fas fa-chevron-up"></i>
        {{ 'JobSummary.Level1' | translate }}
      </button>
    </abi-form-field>
  </ng-template>

  <div class="col-md-6 order-6 order-md-3 pb-2 pb-md-0">
    <div ngbDropdown>
      <button class="btn btn-outline-primary" id="showJob" ngbDropdownToggle>{{ showJobs[showJob] | translate }}</button>
      <div ngbDropdownMenu aria-labelledby="showJob">
        <!--button *ngFor="let sj of showJobs; let index=index" class="dropdown-item" (click)="setShowJob(index)">{{ sj }}</button-->
        <a *ngFor="let sj of showJobs | keyvalue" class="dropdown-item" [routerLink]="['.', showJobParams(sj.key)]"
          [replaceUrl]="true">{{ sj.value | translate }}</a>
      </div>
    </div>
  </div>
  <abi-form-field class="col-md-6 order-4" *ngIf="!filter2; else level2z" label="JobSummary.Level2" labelColClass="col-3" >
    <select [ngModel]="level2" class="custom-select form-control-sm " (change)="groupLevel2($event.target.value)">
      <option *ngFor="let g of groupings" [value]="g.id">{{ g.name | translate }}</option>
    </select>
  </abi-form-field>

  <ng-template #level2z>
    <abi-form-field class="col-md-6 order-4" [label]="groupingName(level2)" labelColClass="col-3">
      <input type="text" [(ngModel)]="filter2" abiProductHint="JobSummary.Level2Filter" aria-label="Level 2 filter"
        class="form-control-plaintext form-control-sm float-left w-60" aria-describedby="button-filter2" readonly>
      <button class="btn btn-outline-secondary d-print-none float-right" type="button" id="button-filter2"
        (click)="groupLevel2(null)">
        <i class="fas fa-chevron-up"></i>
        {{ 'JobSummary.Level2' | translate }}
      </button>
    </abi-form-field>
  </ng-template>

</div>

<div [ngbNavOutlet]="nav"></div>
